
const requiredStaff = {
  //Rates in Order: MAX_GUETS, # OF CHEFS, # OF SOUS CHEF, # OF WAITER / BARTENDER
  'NYC, LA, DC': [
    [6, 1, 0, 0],
    [11, 1, 0, 0],
    [14, 1, 0, 0],
    [20, 1, 1, 0],
    [29, 2, 0, 1],
    [35, 2, 0, 2],
    [44, 3, 0, 3],
    [Infinity, 3, 0, 5]
  ],
  DEFAULT: [
    [12, 1, 0, 0],
    [14, 1, 0, 0],
    [20, 2, 0, 0],
    [30, 2, 0, 1],
    [Infinity, 2, 0, 2],
  ],

  // HAMPTONS
  HMP: [
    [6, 1, 0, 0],
    [12, 1, 0, 0],
    [14, 1, 0, 1],
    [29, 1, 0, 1],
    [Infinity, 2, 0, 2],
  ],
};

const requiredStaffExtendedMenu = {
  //Rates in Order: MAX_GUETS, # OF CHEFS, # OF SOUS CHEF, # OF WAITER / BARTENDER
  'NYC, LA, DC': [
    [6, 2, 0, 0],
    [11, 2, 0, 0],
    [14, 2, 0, 0],
    [20, 2, 0, 0],
    [29, 2, 1, 0],
    [35, 2, 1, 1],
    [44, 3, 1, 2],
    [Infinity, 3, 1, 4]
  ],
  DEFAULT: [
    [12, 2, 0, 0],
    [14, 2, 0, 0],
    [20, 2, 0, 1],
    [30, 2, 0, 2],
    [Infinity, 3, 0, 2],
  ],

  // HAMPTONS
  HMP: [
    [6, 1, 0, 1],
    [12, 2, 0, 0],
    [14, 2, 0, 1],
    [29, 2, 0, 1],
    [Infinity, 3, 0, 2],
  ],
};


export const getStaffRequirements = (district, guestCount, extendedMenu, includes_cocktails) => {
    const rateTable = extendedMenu ? requiredStaffExtendedMenu : requiredStaff;
    let rates = rateTable['DEFAULT']
    switch (district) {
        case 'NYC':
        case 'LA':
        case 'DC':
        case 'CORE':
            rates = rateTable['NYC, LA, DC']
            break;
        case 'HMP':
        case 'PREMIUM':
            rates = rateTable['HMP']
            break;
        default:
    }

    for (const rate of rates) {
        if (guestCount <= rate[0]) {
            const bartenders = includes_cocktails ? Math.max(1, rate[3]) : rate[3];
            return {
                requiredChefs: rate[1],
                requiredSousChefs: rate[2],
                requiredBartenders: bartenders
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/helpers/validateOccasionStaffing.js